const common: Record<string, string> = {
  "nav.home": "Início",
  "nav.articles": "Artigos",
  "nav.categories": "Categorias",
  "nav.guide": "Guia",
  "nav.cta": "cssbuy sheet",
  "footer.brand": "CSSBuy Spreadsheets",
  "footer.description": "Sua fonte confiável de planilhas CSSBuy atualizadas com os melhores produtos da China. Sneakers, roupas, acessórios e muito mais.",
  "footer.addressLabel": "ENDEREÇO",
  "footer.addressValue": "Lisboa, Portugal",
  "footer.phoneLabel": "TELEFONE",
  "footer.phoneValue": "+351 912 345 678",
  "footer.emailLabel": "EMAIL",
  "footer.emailValue": "contato@cssbuyspreadsheets.pics",
  "footer.copyright": "© 2026 CSSBuy Spreadsheets. Todos os direitos reservados.",
  "footer.home": "Início",
  "footer.policy": "Política de Privacidade",
  "footer.terms": "Termos de Uso",
  "footer.disclaimer": "Este site é apenas informativo. Não vendemos produtos diretamente. Todos os links são para fins de referência.",
};

export default common;